<template>
  <div class="DataLoader">
    <slot v-if="response.loading" name="loader">
      <p><strong>Loading...</strong></p>
    </slot>
    <template v-if="!response.loading">
      <slot v-if="response.data" :data="response.data" name="data">
        <p>Success</p>
      </slot>

      <slot v-if="response.error" :error="response.error" name="error">
        <p>Oh no, there was an error with your request.</p>
      </slot>
    </template>
  </div>
</template>
<script>
import { computed } from "vue";
import vueFetch from "@whatsaaaaa/vue-data-fetch/dist";
import { useEventStore } from "./../../../../stores/EventStore";
import { storeToRefs } from "pinia";
export default {
  name: "DataLoader",
  props: {
    url: {
      type: String,
      required: true,
    },
    eventId: {
      type: [Number, String],
      default: null,
    },
  },
  setup(props) {
    const url = computed(() => props.url);
    const events = useEventStore();
    const { getEvent } = storeToRefs(events);

    let response = { data: {} };
    if (getEvent.value(props.eventId)) {
      response.data.data = getEvent.value(props.eventId);
    } else if (props.eventId !== null) {
      response = vueFetch(url);
    }
    return {
      response,
    };
  },
};
</script>
